import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import App from '../components/App';
import * as Actions from '../actions';
import { keyDown, navOnlyFromUri, SET_LANG, PONIES } from '../actions/navigation';
import { browserHistory } from 'react-router';
import { findPrevNextFromUri, trUri } from '../utils';

function mapStateToProps(state, ownProps) {
  const uri = ownProps.location.pathname;
  const universalUri = `/${uri.split('/')[2]}`;
  const sections = state.luraschi.getIn(['data', 'data']).map(i => i.get('meta'));
  const navonly = state.luraschi.get('navonly');
  const lang = state.luraschi.get('lang', ownProps.location.pathname.split('/')[1]);
  const c = sections.find(item => trUri(item, lang) === universalUri);
  const uris = (typeof c === 'undefined') ? {} : c.get('uri');
  return {
    showSection: !navonly && !state.luraschi.getIn(['burger', 'opened'], false),
    prevnext: (navonly) ? findPrevNextFromUri(sections.rest(), universalUri, lang) : [],
    lang,
    uris,
    ready: true,//state.luraschi.hasIn(['slider', 'locked']),
    openedBurger: state.luraschi.getIn(['burger', 'opened'], false),
    lockedSlider: state.luraschi.getIn(['slider', 'locked'], false),
    baseline: state.luraschi.getIn(['data', 'meta', 'baseline', lang]),
  };
}

const toggleLang = (dispatch, uris, lang) => {
  const nextLang = (lang === 'fr') ? 'en' : 'fr';
  const uri = uris.get(nextLang);
  dispatch({ type: SET_LANG, payload: nextLang });
  browserHistory.replace(`/${nextLang}${uri}`);
};

const onKeyDown = ({ keyCode }, dispatch, uris, lang, prevnext) => {
  switch (keyCode) {
    case 76: // l
      toggleLang(dispatch, uris, lang);
      break;
    case 38:
      if (typeof prevnext[0] !== 'undefined') {
        browserHistory.push(`/${lang}${trUri(prevnext[0], lang)}`);
      }
      break;
    case 40:
      if (typeof prevnext[1] !== 'undefined') {
        browserHistory.push(`/${lang}${trUri(prevnext[1], lang)}`);
      }
      break;
    default:
      dispatch(keyDown(keyCode));
  }
};

const wheel = (delta, lang, prevnext) => {
  if (delta > 0) {
    if (typeof prevnext[0] !== 'undefined') {
      browserHistory.push(`/${lang}${trUri(prevnext[0], lang)}`);
    }
  } else {
    if (typeof prevnext[1] !== 'undefined') {
      browserHistory.push(`/${lang}${trUri(prevnext[1], lang)}`);
    }
  }
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
    onKeyDown: (e, uris, lang, prevnext) => onKeyDown(e, dispatch, uris, lang, prevnext),
    onWheel: (delta, lang, prevnext) => wheel(delta, lang, prevnext),
    onKonami: () => dispatch({ type: PONIES }),
    setNavOnlyFromUri: (uri) => dispatch(navOnlyFromUri(uri)),
    langSwitch: (uris, lang) => toggleLang(dispatch, uris, lang),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./common/containers/App.js